import { CaseLine } from '@/models/case-line.model';
import { Case } from '@/models/case.model';
import {
  AccountAddressDto,
  CaseLineDto,
  CaseReturnRequestType,
  CaseType,
  CaseUpdateDto,
  ProductGender,
} from '@onrunning/backstage-models';

export const mappersMixins = {
  genderValueToI18nString(gender: number) {
    switch (gender) {
      case 0:
        return 'unisex';
      case 1:
        return 'male';
      case 2:
        return 'female';
      case 3:
        return 'youth';
      case 4:
        return 'kids';
    }
  },
  genderValueToShortString(gender: number) {
    switch (gender) {
      case ProductGender.unisex:
        return 'U';
      case ProductGender.male:
        return 'M';
      case ProductGender.female:
        return 'W';
      case ProductGender.youth:
        return 'Y';
      case ProductGender.kids:
        return 'K';
    }

    return '';
  },
  mapCaseUpdate(caseUpdate: Case, isPickupRequest = false) {
    const payload: CaseUpdateDto = {
      accountId: caseUpdate.accountId,
      reason: caseUpdate.reason,
      lines: caseUpdate.lines.map((line) => this.mapCaseLineModelToDto(line)) || [],
      type: caseUpdate.type,
      description: caseUpdate.description,
      requestType:
        caseUpdate.type === CaseType.Return
          ? isPickupRequest
            ? CaseReturnRequestType.Pickup
            : CaseReturnRequestType.Label
          : undefined,
      parcelCount: Number(caseUpdate.parcelCount) || 0,
      palletCount: Number(caseUpdate.palletCount) || 0,
    };

    if (payload.requestType === CaseReturnRequestType.Pickup && caseUpdate.pickup) {
      payload.parcelCount = Number(caseUpdate.pickup.parcelCount) || 0;
      payload.palletCount = Number(caseUpdate.pickup.palletCount) || 0;

      payload.pickup = {
        contact: caseUpdate.pickup.contact,
        dimensions: caseUpdate.pickup.dimensions,
        // send address only if it has a valid street name
        address: caseUpdate.pickup.address?.street ? caseUpdate.pickup.address : (null as unknown as AccountAddressDto),
        addressNotes: caseUpdate.pickup.addressNotes,
        pickupDate: caseUpdate.pickup.pickupDate as unknown as Date,
        restrictedAccess: caseUpdate.pickup.restrictedAccess || false,
        totalPackageWeight: caseUpdate.pickup.totalPackageWeight || 0,
        singlePackageWeight: caseUpdate.pickup.singlePackageWeight || 0,
        weightUnit: caseUpdate.pickup.weightUnit,
        tailLiftRequired: caseUpdate.pickup.tailLiftRequired,
        customerReference: caseUpdate.pickup.customerReference,
      };
    }

    return payload;
  },
  mapCaseLineModelToDto(caseLineModel: CaseLine) {
    const caseLineDto = new CaseLineDto();

    caseLineDto.id = caseLineModel.id;
    caseLineDto.productId = caseLineModel.productId;
    caseLineDto.productFabricSize = caseLineModel.productFabricSize;
    caseLineDto.productGroupId = caseLineModel.productGroupId;
    caseLineDto.productGroupName = caseLineModel.productGroupName;
    caseLineDto.productImageUrl = caseLineModel.productImageUrl;
    caseLineDto.productMainGroup = caseLineModel.productMainGroup;
    caseLineDto.productName = caseLineModel.productName;
    caseLineDto.productNumber = caseLineModel.productNumber;
    caseLineDto.quantity = caseLineModel.quantity;
    caseLineDto.distanceRun = caseLineModel.distanceRun;
    caseLineDto.defectReason = caseLineModel.defectReason;
    caseLineDto.comments = caseLineModel.comments;
    caseLineDto.customerName = caseLineModel.customerName;
    caseLineDto.purchaseDate = caseLineModel.purchaseDate;
    caseLineDto.productCode = caseLineModel.productCode;
    caseLineDto.factoryCode = caseLineModel.factoryCode;
    caseLineDto.images = caseLineModel.images;

    return caseLineDto;
  },
};
